import React from 'react'

const IcStoreOff = (props) => <svg {...props} width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle opacity="0.1" cx={16} cy={16} r={16} fill="#959595" />
    <path d="M10 13.9L16.3 9L22.6 13.9V21.6C22.6 21.9713 22.4525 22.3274 22.1899 22.5899C21.9274 22.8525 21.5713 23 21.2 23H11.4C11.0287 23 10.6726 22.8525 10.4101 22.5899C10.1475 22.3274 10 21.9713 10 21.6V13.9Z" stroke="#959595" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
</svg>

export default IcStoreOff
